<template>
    <div class="skeleton-loader" :class="{ 'multiple-cards': cardCount > 1, 'single-card': cardCount === 1 }">
        <!-- Search Bar Skeleton -->
        <div class="skeleton-search-bar">
            <div class="skeleton-search-input"></div>
        </div>

        <!-- Category Filter Skeleton -->
        <div class="skeleton-category-filters">
            <div class="skeleton-filter-pill" v-for="n in 8" :key="'filter-' + n"></div>
        </div>

        <!-- Cards Grid Container -->
        <div class="skeleton-grid-container" :style="{ gridTemplateColumns: `repeat(${cardCount}, 1fr)` }">
            <!-- Card skeletons -->
            <template v-for="cardIndex in cardCount">
                <!-- Remove button -->
                <div :class="`skeleton-remove-btn grid-column-${cardIndex} grid-row-1`"></div>
                
                <!-- Card image -->
                <div :class="`skeleton-card-image grid-column-${cardIndex} grid-row-2`"></div>
                
                <!-- Card title -->
                <div :class="`skeleton-card-title grid-column-${cardIndex} grid-row-3`"></div>
                
                <!-- Apply button -->
                <div :class="`skeleton-apply-btn grid-column-${cardIndex} grid-row-4`"></div>
                
                <!-- Secure site text -->
                <div :class="`skeleton-secure-text grid-column-${cardIndex} grid-row-5`"></div>
                
                <!-- Rates & fees link -->
                <div :class="`skeleton-rates-fees grid-column-${cardIndex} grid-row-6`"></div>
            </template>

            <!-- Section Headers and Details -->
            <!-- Credit Score Section -->
            <div :class="`skeleton-section-header grid-row-7 grid-span-${cardCount + 1}`">
                <div class="skeleton-section-title"></div>
                <div class="skeleton-toggle-icon"></div>
            </div>
            <template v-for="cardIndex in cardCount">
                <div :class="`skeleton-field grid-column-${cardIndex} grid-row-8`"></div>
            </template>

            <!-- Card Type Section -->
            <div :class="`skeleton-section-header grid-row-9 grid-span-${cardCount + 1}`">
                <div class="skeleton-section-title"></div>
                <div class="skeleton-toggle-icon"></div>
            </div>
            <template v-for="cardIndex in cardCount">
                <div :class="`skeleton-field grid-column-${cardIndex} grid-row-10`"></div>
            </template>

            <!-- Sign Up Offers Section -->
            <div :class="`skeleton-section-header grid-row-11 grid-span-${cardCount + 1}`">
                <div class="skeleton-section-title"></div>
                <div class="skeleton-toggle-icon"></div>
            </div>
            <!-- Intro Purchase APR -->
            <div :class="`skeleton-subsection-header grid-row-12 grid-span-${cardCount + 1}`"></div>
            <template v-for="cardIndex in cardCount">
                <div :class="`skeleton-field grid-column-${cardIndex} grid-row-13`"></div>
            </template>
            <!-- Intro Balance Transfer APR -->
            <div :class="`skeleton-subsection-header grid-row-14 grid-span-${cardCount + 1}`"></div>
            <template v-for="cardIndex in cardCount">
                <div :class="`skeleton-field grid-column-${cardIndex} grid-row-15`"></div>
            </template>
            <!-- Welcome Offer -->
            <div :class="`skeleton-subsection-header grid-row-16 grid-span-${cardCount + 1}`"></div>
            <template v-for="cardIndex in cardCount">
                <div :class="`skeleton-field-large grid-column-${cardIndex} grid-row-17`"></div>
            </template>

            <!-- Ongoing Information Section -->
            <div :class="`skeleton-section-header grid-row-18 grid-span-${cardCount + 1}`">
                <div class="skeleton-section-title"></div>
                <div class="skeleton-toggle-icon"></div>
            </div>
            <!-- Reward Rate -->
            <div :class="`skeleton-subsection-header grid-row-19 grid-span-${cardCount + 1}`"></div>
            <template v-for="cardIndex in cardCount">
                <div :class="`skeleton-field-large grid-column-${cardIndex} grid-row-20`"></div>
            </template>
            <!-- APR for purchases -->
            <div :class="`skeleton-subsection-header grid-row-21 grid-span-${cardCount + 1}`"></div>
            <template v-for="cardIndex in cardCount">
                <div :class="`skeleton-field grid-column-${cardIndex} grid-row-22`"></div>
            </template>
            <!-- APR for balance transfer -->
            <div :class="`skeleton-subsection-header grid-row-23 grid-span-${cardCount + 1}`"></div>
            <template v-for="cardIndex in cardCount">
                <div :class="`skeleton-field grid-column-${cardIndex} grid-row-24`"></div>
            </template>
            <!-- APR for cash advance -->
            <div :class="`skeleton-subsection-header grid-row-25 grid-span-${cardCount + 1}`"></div>
            <template v-for="cardIndex in cardCount">
                <div :class="`skeleton-field grid-column-${cardIndex} grid-row-26`"></div>
            </template>

            <!-- Card Fees Section -->
            <div :class="`skeleton-section-header grid-row-27 grid-span-${cardCount + 1}`">
                <div class="skeleton-section-title"></div>
                <div class="skeleton-toggle-icon"></div>
            </div>
            <!-- Annual Fee -->
            <div :class="`skeleton-subsection-header grid-row-28 grid-span-${cardCount + 1}`"></div>
            <template v-for="cardIndex in cardCount">
                <div :class="`skeleton-field grid-column-${cardIndex} grid-row-29`"></div>
            </template>
            <!-- Foreign Transaction Fee -->
            <div :class="`skeleton-subsection-header grid-row-30 grid-span-${cardCount + 1}`"></div>
            <template v-for="cardIndex in cardCount">
                <div :class="`skeleton-field grid-column-${cardIndex} grid-row-31`"></div>
            </template>
            <!-- Balance Transfer Fee -->
            <div :class="`skeleton-subsection-header grid-row-32 grid-span-${cardCount + 1}`"></div>
            <template v-for="cardIndex in cardCount">
                <div :class="`skeleton-field grid-column-${cardIndex} grid-row-33`"></div>
            </template>

            <!-- Additional Card Details Section -->
            <div :class="`skeleton-section-header grid-row-34 grid-span-${cardCount + 1}`">
                <div class="skeleton-section-title"></div>
                <div class="skeleton-toggle-icon"></div>
            </div>
            <template v-for="cardIndex in cardCount">
                <div :class="`skeleton-details-link grid-column-${cardIndex} grid-row-35`"></div>
            </template>
        </div>

        <!-- Single card add more placeholder -->
        <div v-if="cardCount === 1" class="skeleton-add-cards">
            <div class="skeleton-add-cards-content"></div>
        </div>

        <!-- Disclaimer skeleton -->
        <div class="skeleton-disclaimer"></div>
    </div>
</template>

<script>
export default {
    name: 'skeleton-loader',
    props: {
        cardCount: {
            type: Number,
            default: 3,
            validator: (value) => value >= 0 && value <= 4
        }
    }
}
</script>

<style lang="scss" scoped>
.skeleton-loader {
    padding: 20px 0;
    min-height: 1200px;
    box-sizing: border-box;
    overflow: hidden;

    // Base skeleton element styles
    %skeleton-base {
        background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
        background-size: 200% 100%;
        animation: skeleton-loading 1.5s infinite;
        border-radius: 4px;
        box-sizing: border-box;
        flex-shrink: 0;
    }

    @keyframes skeleton-loading {
        0% {
            background-position: 200% 0;
        }
        100% {
            background-position: -200% 0;
        }
    }

    // Search bar skeleton - match real search bar dimensions exactly
    .skeleton-search-bar {
        margin-bottom: 24px;
        min-height: 74px; /* 50px height + 24px margin */
        .skeleton-search-input {
            @extend %skeleton-base;
            height: 50px;
            width: 100%;
            max-width: 500px;
            margin: 0 auto;
            border-radius: 25px;
            box-sizing: border-box;
        }
    }

    .skeleton-category-filters {
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
        justify-content: center;
        margin-bottom: 32px;
        min-height: 68px; /* 36px height + 32px margin */

        .skeleton-filter-pill {
            @extend %skeleton-base;
            height: 36px;
            width: 100px;
            border-radius: 18px;
            flex-shrink: 0;

            &:first-child {
                width: 120px;
                background: linear-gradient(90deg, #d0e7ff 25%, #b8dcff 50%, #d0e7ff 75%);
                background-size: 200% 100%;
            }
        }
    }

    // Grid container - ensure exact match with real content grid
    .skeleton-grid-container {
        display: grid;
        gap: 16px;
        margin-bottom: 32px;
        min-height: 800px;
        box-sizing: border-box;
        width: 100%;
        overflow: hidden;

        // Dynamic grid columns based on card count
        &.multiple-cards {
            grid-template-columns: repeat(var(--card-count, 3), 1fr);
        }

        // Card elements - exact dimensions to match real content
        .skeleton-remove-btn {
            @extend %skeleton-base;
            height: 24px;
            width: 24px;
            border-radius: 50%;
            justify-self: end;
            position: relative;
        }

        .skeleton-card-image {
            @extend %skeleton-base;
            height: 100px;
            width: 156px;
            justify-self: center;
            border-radius: 8px;
            min-width: 156px;
            min-height: 100px;
        }

        .skeleton-card-title {
            @extend %skeleton-base;
            height: 48px;
            width: 90%;
            justify-self: center;
            min-height: 48px;
        }

        .skeleton-apply-btn {
            @extend %skeleton-base;
            height: 40px;
            width: 80%;
            justify-self: center;
            border-radius: 20px;
            background: linear-gradient(90deg, #e8f5e8 25%, #d4edda 50%, #e8f5e8 75%);
            background-size: 200% 100%;
            min-height: 40px;
        }

        .skeleton-secure-text {
            @extend %skeleton-base;
            height: 16px;
            width: 70%;
            justify-self: center;
            min-height: 16px;
        }

        .skeleton-rates-fees {
            @extend %skeleton-base;
            height: 16px;
            width: 60%;
            justify-self: center;
            min-height: 16px;
        }

        // Section headers
        .skeleton-section-header {
            display: flex;
            align-items: center;
            gap: 12px;
            padding: 16px 0;
            border-top: 1px solid #e0e0e0;
            background-color: #f8f9fa;

            .skeleton-section-title {
                @extend %skeleton-base;
                height: 20px;
                width: 180px;
            }

            .skeleton-toggle-icon {
                @extend %skeleton-base;
                height: 16px;
                width: 16px;
                border-radius: 50%;
                margin-left: auto;
            }
        }

        .skeleton-subsection-header {
            @extend %skeleton-base;
            height: 16px;
            width: 120px;
            background-color: #f8f9fa;
            padding: 8px 0;
        }

        .skeleton-field {
            @extend %skeleton-base;
            height: 20px;
            width: 80%;
            justify-self: center;
        }

        .skeleton-field-large {
            @extend %skeleton-base;
            height: 32px;
            width: 90%;
            justify-self: center;
        }

        .skeleton-details-link {
            @extend %skeleton-base;
            height: 18px;
            width: 60%;
            justify-self: center;
        }

        // Grid positioning classes
        @for $i from 1 through 4 {
            .grid-column-#{$i} {
                grid-column: #{$i};
            }
        }

        @for $i from 1 through 35 {
            .grid-row-#{$i} {
                grid-row: #{$i};
            }
        }

        @for $i from 2 through 5 {
            .grid-span-#{$i} {
                grid-column: 1 / span #{$i};
            }
        }
    }

    // Single card add more cards skeleton
    .skeleton-add-cards {
        margin-top: 24px;
        padding: 32px;
        border: 2px dashed #e0e0e0;
        border-radius: 8px;

        .skeleton-add-cards-content {
            @extend %skeleton-base;
            height: 60px;
            width: 60%;
            margin: 0 auto;
        }
    }

    // Disclaimer skeleton
    .skeleton-disclaimer {
        @extend %skeleton-base;
        height: 60px;
        width: 100%;
        margin-top: 32px;
    }

    // Responsive adjustments
    @media (max-width: 768px) {
        .skeleton-grid-container {
            grid-template-columns: 1fr !important;
            
            .skeleton-card-image {
                width: 120px;
                height: 80px;
            }
            
            .skeleton-apply-btn {
                width: 90%;
            }
        }

        .skeleton-category-filters {
            .skeleton-filter-pill {
                width: 80px;
                height: 32px;
            }
        }
    }
}

// Loading state variations
.skeleton-loader.multiple-cards {
    .skeleton-grid-container {
        min-height: 800px;
    }
}

.skeleton-loader.single-card {
    .skeleton-grid-container {
        grid-template-columns: 1fr 1fr 1fr;
        
        .grid-column-1 {
            grid-column: 2;
        }
        
        .grid-span-3 {
            grid-column: 1 / span 3;
        }
    }
}
</style>